import GetLectureLessonStatesRequestModelBase from '../_generated/modelBases/get-lecture-lesson-states-request-model-base';

export default class GetLectureLessonStatesRequestModel extends GetLectureLessonStatesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
